// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

// Importation de Bootstrap-vue
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

// Importation de la configuration (s'adapte selon l'env prod ou dev)
import './public/config.js'

// Importation du store contenant toutes les données partagées entre les composants Vue
import './store.js'

Vue.config.productionTip = false
Vue.prototype.$axios = axios

// // Filtre permettant de mettre au pluriel si besoin
// Vue.filter('pluralize', function(value, choices, showValue=true) {
//     // S'il y a 0 ou 1 élément, on met au singulier, sinon au pluriel
//     let word = (value <= 1) ? choices[0] : choices[1];
//     // Si showValue vaut true, affichage de la valeur avant le mot
//     return showValue ? value + ' ' + word : word;
// });

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js